'use client';

import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  clearPreferredLocale,
  DEFAULT_LOCALE,
  detectInitialLocale,
  normalizeI18nResolvedLanguage,
  type SupportedLocale,
} from '@repo/common/i18n';

import { useUi } from '../contexts/ui-context';

export function I18nLocaleBootstrap({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();

  const { featureFlags, featureFlagsLoading } = useUi();
  const i18nEnabled = featureFlags.includes('language_switcher');

  useEffect(() => {
    if (featureFlagsLoading) {
      return;
    }

    let targetLocale: SupportedLocale;
    if (!i18nEnabled) {
      clearPreferredLocale();
      targetLocale = DEFAULT_LOCALE;
    } else {
      targetLocale = detectInitialLocale();
    }

    const resolved = normalizeI18nResolvedLanguage(i18n.resolvedLanguage);
    if (resolved !== targetLocale) {
      void i18n.changeLanguage(targetLocale);
    }
  }, [featureFlagsLoading, i18n, i18nEnabled]);

  return <>{children}</>;
}
